var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Talent } from 'packages/talent/entities/Talent';
import ENV from 'config/env';
var CandidateRepository = /** @class */ (function (_super) {
    __extends(CandidateRepository, _super);
    function CandidateRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'api/v2/candidates';
        _this.entity = Talent;
        return _this;
    }
    CandidateRepository.prototype.copyCandidates = function (fromJobId, toJobId, talentIds) {
        return this.axios.post(this.url + "/add", {
            from: fromJobId,
            to: [toJobId],
            talents: talentIds,
        }).then();
    };
    CandidateRepository.prototype.addCandidates = function (toJobId, talentIds) {
        return this.axios.post(this.url + "/add", { to: [toJobId], talents: talentIds }).then();
    };
    CandidateRepository.prototype.fetchCandidates = function (companyId, query) {
        return this.getPaginated(ENV.JOBILLA_API_V2_URL + "company/" + companyId + "/talents", null, query.queryData);
    };
    return CandidateRepository;
}(AbstractRepository));
export { CandidateRepository };
